import React from "react";

// react-bootstrap components
import { Container } from "react-bootstrap";
import { properties } from "../../config/ClientConfigurations";
import { useTranslation } from "react-i18next";

function HipposAuthFooter() {
  const { t } = useTranslation();

  return (
    <>
      <footer className="footer position-absolute fixed-bottom">
        <Container>
          <nav>
            <p className="copyright text-center m-0">
              {t("footer.copyright", { year: new Date().getFullYear(), company: properties.companyName })}
            </p>
          </nav>
        </Container>
      </footer>
    </>
  );
}

export default HipposAuthFooter;
